import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Typography } from '@mui/material';
import EmptyListIcon from '@img/empty-list.svg';
import { DataGridTable } from '@shared/ui/data-grid-table';
import {
  $columns,
  $selectRow,
  $tableData,
  columnsWidthChanged,
  orderColumnsChanged,
  selectionRowChanged,
} from '../../../models/related-tickets';
import * as Styled from '../styled';

export const Table = () => {
  const { t } = useTranslation();
  const [columns, tableData, selectRow] = useUnit([$columns, $tableData, $selectRow]);

  const onRowClick = () => {};

  const getRowClassName = () => 'row-selection';

  return (
    <DataGridTable
      key={JSON.stringify(tableData)}
      checkboxSelection
      disableRowSelectionOnClick
      density="compact"
      pagination={false}
      paginationMode="client"
      hideFooter
      columns={columns}
      onColumnWidthChange={columnsWidthChanged}
      onColumnOrderChange={orderColumnsChanged}
      rows={tableData}
      onRowClick={onRowClick}
      getRowClassName={getRowClassName}
      rowSelectionModel={selectRow}
      onRowSelectionModelChange={selectionRowChanged}
      slots={{
        noRowsOverlay: () => (
          <Styled.NoDataOverlay>
            <EmptyListIcon />
            <Typography variant="body1" color="text.secondary">
              {t('RelatedListIsEmpty')}
            </Typography>
          </Styled.NoDataOverlay>
        ),
      }}
    />
  );
};
